module.exports = "<div class=\"viewer\">\r\n\t<div class=\"ace-editor\" ace-editor [(text)]=\"code\"></div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/Akshata/Documents/GitHub/mobius-dev/src/app/ui-components/viewers/code-viewer/code-viewer.component.html
// module id = ../../../../../src/app/ui-components/viewers/code-viewer/code-viewer.component.html
// module chunks = main